import { render, staticRenderFns } from "./Venue.vue?vue&type=template&id=524d66ca&scoped=true"
import script from "./Venue.vue?vue&type=script&lang=js"
export * from "./Venue.vue?vue&type=script&lang=js"
import style0 from "./Venue.vue?vue&type=style&index=0&id=524d66ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524d66ca",
  null
  
)

export default component.exports